import React from 'react';
import './DisplayBoolean.scss';

const DisplayBoolean = ({label, value}) => {
  return (
    <label className='display-boolean'>
      <span className="label">
        {label}
      </span>

      {value &&
        <i className='fa fa-check'/>
      }
      {!value &&
        <i className='fa fa-close'/>
      }
    </label>
  )
};

export default DisplayBoolean;